module.exports = __webpack_public_path__ + "img/card1.6fa920b6.svg";